var _path, _path2, _path3, _path4, _path5, _path6, _rect, _path7, _path8, _path9, _path0, _path1, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrinter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "45px",
    height: "45px",
    viewBox: "0 0 45 45",
    enableBackground: "new 0 0 45 45",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M35.2,7.6l-24.7,5c-1.6,0-2.9,1.3-2.9,2.9v21.8h29.7V15.5c0-1.6-1.3-2.9-2.9-2.9c0,0,0,0,0,0H15.6l19.8-4 c0.3-0.1,0.5-0.3,0.4-0.6C35.8,7.7,35.5,7.6,35.2,7.6z M14.8,26.9H19v1c0,0.6,0.4,1,1,1h4.4c0.6,0,1-0.4,1-1v-1h4.7 c0.4,0,0.8,0.4,0.8,0.8v3.7H14v-3.7C14.1,27.3,14.4,27,14.8,26.9z M14,32.4h5v0.9c-0.1,0.5,0.3,0.9,0.8,1c0.1,0,0.1,0,0.2,0h4.4 c0.5,0.1,0.9-0.3,1-0.8c0-0.1,0-0.1,0-0.2v-0.9h5.5v3.9H14V32.4z M36.3,36.3h-4.4v-8.6c0-1-0.8-1.8-1.8-1.8H14.8 c-1,0-1.8,0.8-1.8,1.8v8.6H8.6V21.5h27.7V36.3z M34.4,13.5c1.1,0.1,1.9,0.9,1.9,2v5H8.6v-5c0-1.1,0.8-1.9,1.9-2H34.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M30.9,36.3v-3.9h-5.5v0.9c0.1,0.5-0.3,0.9-0.8,1c-0.1,0-0.1,0-0.2,0H20c-0.5,0.1-0.9-0.3-1-0.8 c0-0.1,0-0.1,0-0.2v-0.9h-5v3.9H30.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M14,31.4h16.9v-3.7c0-0.4-0.4-0.8-0.8-0.8h-4.7v1c0,0.6-0.4,1-1,1H20c-0.6,0-1-0.4-1-1v-1h-4.2 c-0.4,0-0.8,0.4-0.8,0.8V31.4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M8.6,21.5v14.8H13v-8.6c0-1,0.8-1.8,1.8-1.8h15.3c1,0,1.8,0.8,1.8,1.8v8.6h4.4V21.5H8.6z M18.5,23.9 c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h7.4c0.3,0,0.5,0.2,0.5,0.5s-0.2,0.5-0.5,0.5H18.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M8.6,15.5v5h27.7v-5c0-1.1-0.8-1.9-1.9-2H10.5C9.5,13.6,8.6,14.5,8.6,15.5z M23.5,18.5H23 c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h0.5c0.3,0,0.5,0.2,0.5,0.5S23.7,18.5,23.5,18.5z M25.9,18.5h-0.5c-0.3,0-0.5-0.2-0.5-0.5 s0.2-0.5,0.5-0.5h0.5c0.3,0,0.5,0.2,0.5,0.5S26.2,18.5,25.9,18.5z M32.8,15c1.1-0.1,2,0.8,2.1,1.9S34.2,19,33,19s-2-0.8-2.1-1.9 c0,0,0-0.1,0-0.1C30.9,16,31.8,15.1,32.8,15z M25.4,15.5h0.5c0.3,0,0.5,0.2,0.5,0.5s-0.2,0.5-0.5,0.5h-0.5c-0.3,0-0.5-0.2-0.5-0.5 S25.2,15.5,25.4,15.5z M22.9,15.5h0.5c0.3,0,0.5,0.2,0.5,0.5s-0.2,0.5-0.5,0.5h-0.5c-0.2,0-0.4-0.3-0.4-0.5 C22.5,15.8,22.7,15.6,22.9,15.5z M21,14.5v5H10.1v-5H21z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M10.1,19.5H21v-5H10.1V19.5z M20,15.5v3h-8.9v-3H20z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.1,
    y: 15.5,
    fill: "#FFFFFF",
    width: 8.9,
    height: 3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M30.9,17c0,1.1,0.9,2,2,2s2-0.9,2-2s-0.9-2-2-2c0,0-0.1,0-0.1,0C31.8,15.1,30.9,16,30.9,17z M32.8,16 c0.6,0,1,0.4,1,1c0.1,0.5-0.3,0.9-0.8,1c-0.1,0-0.1,0-0.2,0c-0.5,0-0.9-0.4-0.9-0.9c0,0,0-0.1,0-0.1C31.9,16.5,32.3,16.1,32.8,16z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#28B557",
    d: "M31.9,17c-0.1,0.5,0.3,0.9,0.8,1c0,0,0.1,0,0.1,0c0.5,0.1,0.9-0.3,1-0.8c0-0.1,0-0.1,0-0.2c0-0.6-0.4-1-1-1 C32.3,16.1,31.9,16.5,31.9,17z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M26.4,23.5c0-0.3-0.2-0.5-0.5-0.5h-7.4c-0.3,0-0.5,0.2-0.5,0.5c0,0.3,0.2,0.5,0.5,0.5h7.4 C26.2,23.9,26.4,23.7,26.4,23.5z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#28B557",
    d: "M23,16.5h0.5c0.3,0,0.5-0.2,0.5-0.5s-0.2-0.5-0.5-0.5H23c-0.2,0-0.4,0.3-0.4,0.5 C22.5,16.3,22.7,16.5,23,16.5z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#F2724A",
    d: "M23.5,17.5H23c-0.3,0-0.5,0.2-0.5,0.5s0.2,0.5,0.5,0.5h0.5c0.3,0,0.5-0.2,0.5-0.5S23.7,17.5,23.5,17.5z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#4AB8DC",
    d: "M25.4,16.5h0.5c0.3,0,0.5-0.2,0.5-0.5s-0.2-0.5-0.5-0.5h-0.5c-0.3,0-0.5,0.2-0.5,0.5S25.2,16.5,25.4,16.5z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M25.9,17.5h-0.5c-0.3,0-0.5,0.2-0.5,0.5s0.2,0.5,0.5,0.5h0.5c0.3,0,0.5-0.2,0.5-0.5S26.2,17.5,25.9,17.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrinter);
export default __webpack_public_path__ + "static/media/printer.b606f53e246c90d6fd2fe4baf8b330bd.svg";
export { ForwardRef as ReactComponent };